import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import pedicare from "../../../Assets/Projects/mobile/Pedicare.png";
import pedicare2 from "../../../Assets/Projects/mobile/Pedicare2.png";
import pedicare3 from "../../../Assets/Projects/mobile/Pedicare3.png";
import pedicare4 from "../../../Assets/Projects/mobile/Pedicare4.png";
import pedicare5 from "../../../Assets/Projects/mobile/Pedicare5.png";
import pedicare6 from "../../../Assets/Projects/mobile/Pedicare6.png";
import pedicare7 from "../../../Assets/Projects/mobile/Pedicare7.png";
import pedicare8 from "../../../Assets/Projects/mobile/Pedicare8.png";
import pedicare9 from "../../../Assets/Projects/mobile/Pedicare9.png";

function PediCare() {
  return (
    <ProjectDetailCard
      title="PediCare (Patient Digital Care)"
      image={pedicare}
      screenshots={[pedicare2, pedicare3, pedicare4]}
      description="
      PediCare is a mobile healthcare application designed to help parents monitor their children's growth and health in a simple and accessible way. The application provides features for recording children's health data, monitoring growth progress, scheduling immunizations, and accessing healthcare information through an intuitive and user-friendly interface. Designed with a mobile-first approach, PediCare focuses on improving usability, accessibility, and digital healthcare services for parents and caregivers.
      "
      technologies={[
        "Flutter",
        "Dart",
        "Firebase",
        "REST API",
        "Figma",
        "UI/UX Design",
        "Mobile Development",
        "Git",
      ]}
      github="https://github.com/Rezaananda28"
      demo="https://www.figma.com/proto/NfkcMuF5Bn7QLvVbSNybVL/Lansiaga?node-id=30-545&p=f&t=ZgsAMuomPMDGJGiI-1&scaling=scale-down&content-scaling=fixed&page-id=30%3A309&starting-point-node-id=30%3A519&show-proto-sidebar=1"
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={pedicare5} alt="gallery1" />
          <img src={pedicare6} alt="gallery2" />
          <img src={pedicare7} alt="gallery3" />
          <img src={pedicare8} alt="gallery4" />
          <img src={pedicare9} alt="gallery5" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default PediCare;
